import { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import ServiceDetailModal from './ServiceDetailModal';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_7a187c08-1566-4a5d-94a6-902036d37fa8/artifacts/oin9oc2t_Untitled%20design%20%2814%29.png";

const services = [
  {
    title: 'Self-Service Laundry',
    desc: 'Coin-operated washers & dryers, including extra-large machines.',
    image: 'https://customer-assets.emergentagent.com/job_poly-laundry-pro/artifacts/g16y2r3t_IMG_9675.png',
    color: 'from-sky-500/80 to-sky-700/80',
    span: 'sm:col-span-2 sm:row-span-2',
    large: true,
  },
  {
    title: 'Wash, Dry & Fold',
    desc: 'Drop off and we handle the rest with care.',
    image: 'https://images.unsplash.com/photo-1737065183310-aef762bd011c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwyfHxjbGVhbiUyMGZvbGRlZCUyMHRvd2VscyUyMGxhdW5kcnl8ZW58MHx8fHwxNzc2MDIxNjkzfDA&ixlib=rb-4.1.0&q=85',
    color: 'from-blue-600/80 to-blue-800/80',
    span: '',
    large: false,
  },
  {
    title: 'Pickup & Delivery',
    desc: 'Free pickup & delivery around Mountain Home.',
    image: 'https://customer-assets.emergentagent.com/job_poly-laundry-pro/artifacts/pc2fgoq4_IMG_2926.jpeg',
    color: 'from-orange-500/80 to-orange-700/80',
    span: '',
    large: false,
  },
  {
    title: 'Ironing & Pressing',
    desc: 'Professional pressing for any occasion.',
    image: 'https://customer-assets.emergentagent.com/job_poly-laundry-pro/artifacts/otfrmgum_IMG_3496.jpeg',
    color: 'from-emerald-500/80 to-emerald-700/80',
    span: '',
    large: false,
  },
  {
    title: 'Alterations',
    desc: 'Basic alterations and adjustments.',
    image: 'https://customer-assets.emergentagent.com/job_poly-laundry-pro/artifacts/kst4iadj_IMG_3495.jpeg',
    color: 'from-violet-500/80 to-violet-700/80',
    span: '',
    large: false,
  },
  {
    title: 'Commercial Laundry',
    desc: 'Reliable service for businesses.',
    image: 'https://customer-assets.emergentagent.com/job_poly-laundry-pro/artifacts/b5es0hlx_att.vBedXlPyhABcT1sYeX7VDQK148nUOQMXtIyqY5_qkaE.jpeg',
    color: 'from-indigo-600/80 to-indigo-800/80',
    span: 'sm:col-span-2',
    large: false,
  },
];

export default function ServicesSection() {
  const [selectedService, setSelectedService] = useState(null);

  return (
    <section id="services" className="py-24 md:py-32 bg-white" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Section Header */}
        <div className="flex items-end justify-between mb-12 reveal">
          <div className="max-w-xl">
            <div className="flex items-center gap-3 mb-3">
              <div className="bg-white rounded-full p-1 shadow-md ring-1 ring-slate-100">
                <img src={LOGO_URL} alt="Poly Clean Center" className="w-8 h-8 object-contain" />
              </div>
              <span className="text-poly-blue-light font-semibold text-sm tracking-wider uppercase">Our Services</span>
            </div>
            <h2 className="font-heading font-bold text-3xl sm:text-4xl lg:text-5xl text-poly-blue-dark tracking-tight">
              What We <span className="text-poly-blue">Offer</span>
            </h2>
          </div>
        </div>

        {/* Visual Service Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 auto-rows-[200px]">
          {services.map((service, i) => (
            <button
              key={i}
              onClick={() => setSelectedService(service.title)}
              className={`service-card group relative rounded-2xl overflow-hidden cursor-pointer text-left ${service.span} reveal reveal-delay-${Math.min(i + 1, 5)}`}
              data-testid={`service-card-${i}`}
            >
              <img
                src={service.image}
                alt={service.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                loading="lazy"
              />
              <div className={`absolute inset-0 bg-gradient-to-t ${service.color} opacity-70 group-hover:opacity-85 transition-opacity duration-300`} />
              <div className="relative z-10 h-full flex flex-col justify-end p-5">
                <h3 className={`font-heading font-bold text-white ${service.large ? 'text-2xl sm:text-3xl' : 'text-lg'} mb-1`}>
                  {service.title}
                </h3>
                <p className={`text-white/85 ${service.large ? 'text-base' : 'text-sm'} leading-snug`}>
                  {service.desc}
                </p>
                <span className="inline-flex items-center gap-1 text-white/90 text-sm font-semibold mt-3 group-hover:gap-2 transition-all">
                  Learn More <ArrowRight className="w-4 h-4" />
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Service Detail Modal */}
      <ServiceDetailModal
        serviceName={selectedService}
        open={!!selectedService}
        onClose={() => setSelectedService(null)}
      />
    </section>
  );
}
